import { GetApiRequest } from '@/plugins/api/base'

export class GetLineCountries extends GetApiRequest {
  constructor(context, data) {
    const culture = context.i18n.locale.value

    const url = `/api/line/${culture}/countries/sport${data.sportId}/${data.startsWithin}`
    super(context, url)
  }
}
